module.exports = __webpack_public_path__ + "static/img/Skateboard-3.ca286b39.png";